module.exports = __webpack_public_path__ + "static/media/Dysmate-image.7853333f.png";